module.exports = __webpack_public_path__ + "images/carlos-veiga@2x.1348d389094fbe2de1d3f25895a81595.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/carlos-veiga@2x.jpeg
// module id = 1027
// module chunks = 0